<script>
import useConfiguration from "@/use/Configuration";
import {onMounted} from "vue";
import {useSecurityStore} from "@/stores/Security";

export default {
    name: "TrainingRequestConfiguration",
    setup() {
        const {loading, configurations, findAll, save} = useConfiguration();
        
        const securityStore = useSecurityStore();
        
        
        onMounted(() => findAll());
        
        return {
            securityStore,
            loading,
            configurations,
            save,
        }
    }
};
</script>

<template>
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_NOTIFICATION_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>
        
        <template #content>
            <v-container fluid>
                <v-row dense>
                    <v-col cols="6">
                        <w-label :label="$t('alarm.verification_period')"/>
                        <w-text-field
                            v-model="configurations[48].intt"
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6">
                        <w-label :label="$t('alarm.verification_period_unit')"/>
                        <w-enum-select
                            v-model="configurations[49].strr"
                            :items="[
                                {id: 'MINUTES', name: $t('common.minutes')},
                                {id: 'HOURS', name: $t('common.hours')},
                            ]"
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6">
                        <w-label :label="$t('alarm.notification_title')"/>
                        <w-text-field
                            v-model="configurations[50].strr"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </w-app>
</template>